import { render, staticRenderFns } from "./l-edit-group-popup.vue?vue&type=template&id=2fa3f729&scoped=true"
import script from "./l-edit-group-popup.vue?vue&type=script&lang=js"
export * from "./l-edit-group-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa3f729",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa3f729')) {
      api.createRecord('2fa3f729', component.options)
    } else {
      api.reload('2fa3f729', component.options)
    }
    module.hot.accept("./l-edit-group-popup.vue?vue&type=template&id=2fa3f729&scoped=true", function () {
      api.rerender('2fa3f729', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mlocalization/views/popups/l-edit-group-popup.vue"
export default component.exports